var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9165 7.5C2.9165 5.29086 4.70736 3.5 6.9165 3.5H21.0832C23.2923 3.5 25.0832 5.29086 25.0832 7.5V20.5C25.0832 22.7091 23.2923 24.5 21.0832 24.5H6.9165C4.70736 24.5 2.9165 22.7091 2.9165 20.5V7.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.625 19.8333L7.625 14L9.625 14L9.625 19.8333L7.625 19.8333Z",
    fill: "#1A1B1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.875 19.834V9.33398H14.875V19.834H12.875Z",
    fill: "#1A1B1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.375 19.8327L18.375 11.666H20.375L20.375 19.8327H18.375Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIconWhite);
export default __webpack_public_path__ + "static/media/graph-icon-white.dc55a08e85f6d8d7f58f75dc9914a735.svg";
export { ForwardRef as ReactComponent };